/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ActionType, DelayUnit } from './Sequences.types';

/** AddBulkFileRequest */
export interface IAddBulkFileRequest {
  /** File Name */
  file_name: string;
  /**
   * File Format
   * @default "csv"
   */
  file_format?: string;
  /** Raw File Content */
  raw_file_content: string;
  parsing_method: IParsingMethods;
  input_column_mapping?: IColumnMappingPayload | null;
  /** File Source */
  file_source?: string | null;
  /** Default Country Code */
  default_country_code: string;
  /** Sequence Id */
  sequence_id?: string | null;
}

/** AddOrUpdateAutorunScheduleRequest */
export interface IAddOrUpdateAutorunScheduleRequest {
  /** Cron Expression */
  cron_expression: string;
  /** Num Leads Per Trigger */
  num_leads_per_trigger: number;
  /**
   * Schedule Status
   * @default "ENABLED"
   */
  schedule_status?: string;
}

/** Agent */
export interface IAgent {
  /**
   * Id
   * @format uuid
   */
  ID: string;
  /** Name */
  Name: string;
}

/** AgentConversationResponse */
export interface IAgentConversationResponse {
  /**
   * Agentid
   * @format uuid
   */
  AgentID: string;
  /**
   * Orgid
   * @format uuid
   */
  OrgID: string;
  /** Conversationid */
  ConversationID: string;
  /** Messages */
  Messages: IAgentMessageResponse[];
  /** Scheduledmessages */
  ScheduledMessages: IAgentMessageResponse[];
  /** Classification */
  Classification: string;
}

/** AgentFormData */
export interface IAgentFormData {
  /** Elements */
  Elements: IAgentFormDataElement[];
  /** Prompttemplate */
  PromptTemplate: string;
}

/** AgentFormDataElement */
export interface IAgentFormDataElement {
  /**
   * Formelementid
   * @format uuid
   */
  FormElementID: string;
  /** Value */
  Value: string;
}

/** AgentMessageResponse */
export interface IAgentMessageResponse {
  /**
   * Messageid
   * @format uuid
   */
  MessageID: string;
  /** Content */
  Content: string;
  /** Inbound */
  Inbound: boolean;
  /**
   * Timestamp
   * @format date-time
   */
  Timestamp: string;
}

/** AgentNameChangeRequest */
export interface IAgentNameChangeRequest {
  /** New Name */
  new_name: string;
}

/** AgentPreview */
export interface IAgentPreview {
  /**
   * Agentid
   * @format uuid
   */
  AgentID: string;
  /** Name */
  Name: string;
}

/** AgentPromptResponse */
export interface IAgentPromptResponse {
  /** Prompttemplate */
  PromptTemplate: string;
}

/** AgentResponse */
export interface IAgentResponse {
  /**
   * Agentid
   * @format uuid
   */
  AgentID: string;
  /** Name */
  Name: string;
  /** Hasdraft */
  HasDraft: boolean;
  Type: IAgentTypes;
}

/** AgentTypes */
export enum IAgentTypes {
  SINGLE = 'SINGLE',
  MULTI = 'MULTI',
}

/** AgentVersionPreview */
export interface IAgentVersionPreview {
  /** Isdraft */
  IsDraft: boolean;
  /** Versionname */
  VersionName: string;
  /** Versionid */
  VersionID?: string | null;
}

/** AgentVersionResponse */
export interface IAgentVersionResponse {
  /** Isdraft */
  IsDraft: boolean;
  /**
   * Form
   * @default []
   */
  Form?: IFormElement[];
  /** Versionname */
  VersionName: string;
  /** Versionid */
  VersionID?: string | null;
  /** Publishedat */
  PublishedAt?: string | null;
}

/** AgentVersionTypes */
export enum IAgentVersionTypes {
  Draft = 'draft',
  Published = 'published',
}

/** AgentVersionsResponse */
export interface IAgentVersionsResponse {
  /** Versions */
  Versions: IAgentVersionPreview[];
}

/** AgentsResponse */
export interface IAgentsResponse {
  /** Agents */
  Agents: IAgentPreview[];
}

/** AutorunScheduleResponse */
export interface IAutorunScheduleResponse {
  /** Cronexpression */
  CronExpression: string;
  /** Numleads */
  NumLeads: number;
  /** Schedulestatus */
  ScheduleStatus: string;
  /** Nextrun */
  NextRun: string;
}

/** Body_create_whatsapp_profile_v1_integrations_whatsapp_profile_post */
export interface IBodyCreateWhatsappProfileV1IntegrationsWhatsappProfilePost {
  /** Request */
  request: string;
  /**
   * Picture
   * @format binary
   */
  picture: File;
}

/** BulkLeadFileResponse */
export interface IBulkLeadFileResponse {
  /**
   * Fileid
   * @format uuid
   */
  FileID: string;
  /** Filename */
  FileName: string;
  /** Fileformat */
  FileFormat: string;
  /** Filestatus */
  FileStatus: string;
  /** Uploadtimestamp */
  UploadTimestamp?: string | null;
  /** Parsedtimestamp */
  ParsedTimestamp?: string | null;
  /** Processedtimestamp */
  ProcessedTimestamp?: string | null;
  /** Inputnumrows */
  InputNumRows?: number | null;
  /** Parsednumrows */
  ParsedNumRows?: number | null;
  /** Processingnumrows */
  ProcessingNumRows?: number | null;
  /** Sequenceid */
  SequenceID?: string | null;
}

/** BulkLeadResponse */
export interface IBulkLeadResponse {
  /** Success */
  success: boolean;
  /** Message */
  message: string;
}

/** Channel */
export enum IChannel {
  INSTAGRAM = 'INSTAGRAM',
  WHATSAPP = 'WHATSAPP',
}

/** ColumnMappingPayload */
export interface IColumnMappingPayload {
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name?: string | null;
  /** Phone Number */
  phone_number: string;
}

/** ConversationGoal */
export enum IConversationGoal {
  None = 'none',
  Callback = 'callback',
  BookCall = 'book-call',
}

export enum IConversationGoalDescription {
  None = 'No call strategy needed',
  Callback = 'Check if the lead agrees to a callback from your team',
  BookCall = 'Ask the lead to book a call directly',
}

/** ConversationPreview */
export interface IConversationPreview {
  /** Leadid */
  LeadID: string;
  /** Firstname */
  FirstName: string;
  /** Lastname */
  LastName: string | null;
  /** Phonenumber */
  PhoneNumber: string;
  LatestMessage: IMessage;
  /** Classification */
  Classification: string;
  /**
   * Createdat
   * @format date-time
   */
  CreatedAt: string;
}

/** ConversationsResponse */
export interface IConversationsResponse {
  /** Previews */
  Previews: IConversationPreview[];
  /** Lastleadid */
  LastLeadID: string | null;
}

/** CreateAgentConversationRequest */
export interface ICreateAgentConversationRequest {
  /** Versionid */
  VersionID?: string | null;
  /** Version */
  Version?: string | null;
  /** Templateid */
  TemplateID?: string | null;
}

/** CreateAgentMessageRequest */
export interface ICreateAgentMessageRequest {
  /** Content */
  Content: string;
  /**
   * Sentat
   * @format date-time
   */
  SentAt: string;
  /** Versionid */
  VersionID?: string | null;
  /** Version */
  Version?: string | null;
}

/** CreateSequenceRequest */
export type ICreateSequenceRequest = {
  /** Name */
  Name: string;
  Trigger: ITriggerType;
  /** Inboundresponsedelay */
  InboundResponseDelay: number;
  /** Inboundresponsedelay unit */
  InboundResponseDelayUnit: DelayUnit;
  /** Flow */
  Flow: (IWhatsappFlowStep | IInstagramFlowStep)[];
  /**
   * Agentid
   * @format uuid
   */
  AgentID?: string | null;
  /**
   * Profileid
   * @format uuid
   */
  ProfileID?: string | null;
  Active?: boolean;
  ShouldContinueExistingConversations?: boolean;
  DisableAiOnManualConversations?: boolean;
  WorkingHours?: {
    Enabled: boolean;
    From: string | null;
    To: string | null;
    Timezone: string | null;
  };
  /** Trigger keywords for specific sequences */
  Keywords?: string[] | null;
  /** Instagram media IDs for post-scoped sequences */
  TargetMediaIds?: string[] | null;
  /** When false, conversations created by this sequence will have the AI agent disabled */
  EnableAgentOnConversation?: boolean;
  /** When true, AI-generated messages require manual approval before being sent */
  RequireManualApproval?: boolean;
};

/** DataResponse */
export interface IDataResponse {
  /**
   * Contacts
   * @default 0
   */
  Contacts?: number;
  /**
   * Classifications
   * @default {"undetermined":0,"engaged":0,"positive":0,"negative":0}
   */
  Classifications?: object;
}

/** Flow */
export interface IFlow {
  /** Steps */
  Steps: IFlowStep[];
}

/** FlowStep */
export interface IFlowStep {
  /**
   * Templateid
   * @format uuid
   */
  TemplateID?: string;
  /** Name */
  Name: string;
  /** Content */
  Content?: string;
  /** Delay */
  Delay: number;
  DelayUnit: DelayUnit;
  FollowupDelays?: { Delay: number; DelayUnit: DelayUnit; Content?: string }[] | null;
  Action?: ActionType;
  Buttons?: { Title: string; URL: string }[] | null;
  QuickReplies?: { Title: string; Payload: string }[] | null;
  AudioUrl?: string | null;
  VideoUrl?: string | null;
}

/** FormElement */
export interface IFormElement {
  /**
   * Id
   * @format uuid
   */
  ID: string;
  /** Name */
  Name: string;
  /** Value */
  Value: string;
  /** Description */
  Description: string;
  /** Inputtype */
  InputType: string;
  /** Options */
  Options?: string[] | null;
  /** Required */
  Required: boolean;
  /** Editable */
  Editable: boolean;
}

/** HTTPValidationError */
export interface IHTTPValidationError {
  /** Detail */
  detail?: IValidationError[];
}

/** InitializeIntegrationRequest */
export interface IInitializeIntegrationRequest {
  /** Access Token */
  access_token: string;
}

/** LeadInformation */
export interface ILeadInformation {
  /** Leadid */
  LeadID: string;
  /** Firstname */
  FirstName: string;
  /** Lastname */
  LastName: string | null;
  /** Phonenumber */
  PhoneNumber: string;
  /**
   * Createdat
   * @format date-time
   */
  CreatedAt: string;
  /** Leadintegration */
  LeadIntegration: string;
  /** Orgid */
  OrgId: string;
}

/** LeadResponse */
export interface ILeadResponse {
  /** Isactive */
  IsActive: boolean;
  /** Classification */
  Classification: string;
  /** Conversationhistory */
  ConversationHistory: IMessage[];
  /** Upcomingmessages */
  UpcomingMessages: IMessage[];
  LeadInformation: ILeadInformation;
}

/** ManualLeadsTriggerRequest */
export interface IManualLeadsTriggerRequest {
  /** Num Leads To Trigger */
  num_leads_to_trigger: number;
  /** File Id */
  file_id?: string | null;
}

/** Message */
export interface IMessage {
  /** Content */
  Content: string;
  /** Inbound */
  Inbound: boolean;
  /**
   * Timestamp
   * @format date-time
   */
  Timestamp: string;
}

/** MultiAgentCreate */
export interface IMultiAgentCreate {
  /** Name */
  name: string;
  nextMessageAgent: INextMessageAgentPropsInput;
}

/** MultiAgentMessageTimeRange */
export interface IMultiAgentMessageTimeRange {
  /** Min */
  Min: number;
  /** Max */
  Max: number;
}

/** MultiAgentPrompt */
export interface IMultiAgentPrompt {
  NextMessageTimeRange?: IMultiAgentMessageTimeRange | null;
  ResponseNeededAgent: IMultiAgentPromptPart;
  NextMessageAgent: IMultiAgentPromptPart;
  ClassificationAgent: IMultiAgentPromptPart;
  EmojiStep?: IMultiAgentPromptRandomStepPart | null;
}

/** MultiAgentPromptPart */
export interface IMultiAgentPromptPart {
  /** Prompt */
  Prompt: string;
  /** Llmmodel */
  LlmModel?: string | null;
}

/** MultiAgentPromptRandomStepPart */
export interface IMultiAgentPromptRandomStepPart {
  /** Frequency */
  Frequency: number;
  /** Values */
  Values: string[];
  /**
   * Prompt
   * @default "Ajoutez des emojis où cela est approprié pour améliorer le ton conversationnel. Emojis suggérés : {values}"
   */
  Prompt?: string;
}

/** MultiAgentSource */
export enum IMultiAgentSource {
  MANUAL = 'MANUAL',
  AI = 'AI',
  DEFAULT = 'DEFAULT',
}

/** MultiAgentSpecsResponse */
export interface IMultiAgentSpecsResponse {
  /** Name */
  name: string;
  nextMessageAgent: INextMessageAgentPropsOutput;
}

/** NextMessageAgentProps */
export interface INextMessageAgentPropsInput {
  nextMessagePromptSource: IMultiAgentSource;
  /** Nextmessageprompt */
  nextMessagePrompt?: string | null;
  nextMessagePromptAISpecifications?: INextMessagePromptAISpecifications | null;
  nextMessageTimeRange?: IMultiAgentMessageTimeRange | null;
}

/** NextMessageAgentProps */
export interface INextMessageAgentPropsOutput {
  nextMessagePromptSource: IMultiAgentSource;
  /** Nextmessageprompt */
  nextMessagePrompt?: string | null;
  nextMessagePromptAISpecifications?: INextMessagePromptAISpecifications | null;
  nextMessageTimeRange?: IMultiAgentMessageTimeRange | null;
}

/** NextMessagePromptAISpecifications */
export interface INextMessagePromptAISpecifications {
  /** Aipersonality */
  aiPersonality: string;
  language: IPromptLanguage;
  /** Businessdescription */
  businessDescription: string;
  /** Offerdetails */
  offerDetails: string;
  /** Qualificationquestions */
  qualificationQuestions: string[];
  goal: IConversationGoal;
  /** Goaldescription */
  goalDescription: string;
  /** Bookingcalllink */
  bookingCallLink: string | null;
  /**
   * Emojifrequency
   * @min 0
   * @max 1
   */
  emojiFrequency: number;
  /** Emojilist */
  emojiList: string[];
  /**
   * Directness
   * @min 0
   * @max 10
   */
  directness: number;
  /** Generalinstructions */
  generalInstructions?: string | null;
  /** Salesscript */
  salesScript?: string | null;
  /** Followupinstructions */
  followUpInstructions?: string | null;
  /** Responseinstructions */
  responseInstructions?: string | null;
  /** Resources */
  resources?: IResourceItem[] | null;
}

export interface IResourceItem {
  /** Title */
  title: string;
  /** Url */
  url: string;
  /** Description */
  description?: string | null;
}

/** ParsingMethods */
export enum IParsingMethods {
  InputColumnMapping = 'InputColumnMapping',
  FileSourceMapping = 'FileSourceMapping',
}

/** PromptLanguage */
export enum IPromptLanguage {
  ARABIC = 'Arabic',
  CHINESE = 'Chinese',
  DUTCH = 'Dutch',
  English = 'English',
  French = 'French',
  GERMAN = 'German',
  HEBREW = 'Hebrew',
  HINDI = 'Hindi',
  INDONESIAN = 'Indonesian',
  ITALIAN = 'Italian',
  JAPANESE = 'Japanese',
  KOREAN = 'Korean',
  POLISH = 'Polish',
  PORTUGUESE = 'Portuguese',
  RUSSIAN = 'Russian',
  SPANISH = 'Spanish',
  SWEDISH = 'Swedish',
  THAI = 'Thai',
  TURKISH = 'Turkish',
  VIETNAMESE = 'Vietnamese',
}

/** PublishRequest */
export interface IPublishRequest {
  /** Version Name */
  version_name: string;
}

/** SelectInstagramPageRequest */
export interface ISelectInstagramPageRequest {
  /** Page Id */
  page_id: string;
}

/** Instagram media item from the Graph API */
export interface IInstagramMediaItem {
  id: string;
  caption?: string | null;
  permalink?: string | null;
  media_url?: string | null;
  thumbnail_url?: string | null;
  timestamp?: string | null;
  media_type?: 'IMAGE' | 'VIDEO' | 'CAROUSEL_ALBUM' | null;
  media_product_type?: 'FEED' | 'REELS' | 'STORY' | 'AD' | null;
}

export interface IInstagramMediaResponse {
  items: IInstagramMediaItem[];
  next_cursor?: string | null;
}

/** Sequence */
export interface ISequence {
  /** Active */
  Active: boolean;
  /**
   * Id
   * @format uuid
   */
  ID: string;
  /** Name */
  Name: string;
  /** Trigger */
  Trigger: ITriggerType;
  Flow: IFlow | null;
  /** Inboundresponsedelay */
  InboundResponseDelay: number | null;
  /** Unit */
  InboundResponseDelayUnit: DelayUnit;
  Agent: IAgent;
  ProfileID?: string;
  Channel: IChannel;
  Type: 'OUTBOUND' | 'INBOUND';
  ShouldContinueExistingConversations?: boolean;
  DisableAiOnManualConversations?: boolean;
  EnableAgentOnConversation?: boolean;
  RequireManualApproval?: boolean;
  DisabledReason?: string | null;
  /** Working hours configuration */
  WorkingHours?: {
    Enabled: boolean;
    From: string | null;
    To: string | null;
    Timezone: string | null;
  };
  /** Trigger keywords for specific sequences */
  Keywords?: string[] | null;
  /** Instagram media IDs for post-scoped sequences */
  TargetMediaIds?: string[] | null;
}

/** SequencePreview */
export interface ISequencePreview {
  /** Active */
  Active: boolean;
  /**
   * Id
   * @format uuid
   */
  ID: string;
  /** Name */
  Name: string;
  /** Trigger */
  Trigger: string;
  /** Trigger keywords for specific sequences */
  Keywords?: string[] | null;
}

/** SubscribeInstagramRequest */
export interface ISubscribeInstagramRequest {
  /** Field */
  field: string;
}

/** Trigger */
export interface ITrigger {
  /** Name */
  Name: string;
  /** Inbound */
  Inbound: boolean;
}

/** TriggerType */
export enum ITriggerType {
  CONTACT_CREATED = 'CONTACT_CREATED',
  CONTACT_SUBSCRIBED_TO_SEQUENCE = 'CONTACT_SUBSCRIBED_TO_SEQUENCE',
  WHATSAPP_MESSAGE = 'WHATSAPP_MESSAGE',
  INSTAGRAM_COMMENT = 'INSTAGRAM_COMMENT',
  INSTAGRAM_MESSAGE = 'INSTAGRAM_MESSAGE',
  INSTAGRAM_STORY_REPLY = 'INSTAGRAM_STORY_REPLY',
}

/** UpdateMultiAgent */
export interface IUpdateMultiAgent {
  nextMessageAgent: INextMessageAgentPropsInput;
}

/** UpdateSequenceRequest */
export type IUpsertSequenceRequest = ICreateSequenceRequest & {
  SequenceID?: string;
};

/** UpdateSequenceStatusRequest */
export interface IUpdateSequenceStatusRequest {
  /** Active */
  Active: boolean;
}

/** ValidationError */
export interface IValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** WhatsappAccount */
export interface IWhatsappAccount {
  /**
   * Account Connected
   * @default false
   */
  account_connected?: boolean;
}

/** WhatsappEmbedSignupRequest */
export interface IWhatsappEmbedSignupRequest {
  /** Wabaid */
  WabaID: string;
  /** Phoneid */
  PhoneID: string;
  /** Exchangetoken */
  ExchangeToken: string;
  /** Redirecturi */
  RedirectURI: string;
}

/** WhatsappFlowStep */
export interface IWhatsappFlowStep {
  Delay: number;
  DelayUnit: DelayUnit;
  /**
   * Templateid
   * @format uuid
   */
  TemplateID?: string;
  /** Used for personal WhatsApp (no templates) */
  MessageContent?: string;
  /** Voice message URL for personal WhatsApp */
  AudioUrl?: string;
  /** PTV (round video) S3 key for personal WhatsApp */
  VideoUrl?: string;
  FollowupDelays: { Delay: number; DelayUnit: DelayUnit; Content?: string }[];
}

export interface IInstagramFlowStep {
  Delay: number;
  DelayUnit: DelayUnit;
  MessageContent?: string;
  FollowupDelays: { Delay: number; DelayUnit: DelayUnit; Content?: string }[];
  Action?: ActionType;
  Buttons?: { Title: string; URL: string }[] | null;
  QuickReplies?: { Title: string; Payload: string }[] | null;
  AudioUrl?: string | null;
}

/** WhatsappInboundUrlRequest */
export interface IWhatsappInboundUrlRequest {
  /** Text */
  Text: string;
}

/** WhatsappPhoneResponse */
export interface IWhatsappPhoneResponse {
  /** Phoneid */
  PhoneID: string;
  /** Phonenumber */
  PhoneNumber: string;
  /** Status */
  Status: string;
  /** Inboundmessageurl */
  InboundMessageUrl?: string | null;
}

/** WhatsappProfileResponse */
export interface IWhatsappProfileResponse {
  /**
   * Profileid
   * @format uuid
   */
  ProfileID: string;
  /** Profilename */
  ProfileName: string;
  /** Numphones */
  NumPhones: number;
  /** Profilepicture */
  ProfilePicture: string;
  /** Dailylimit */
  MessagesDailyLimit: number;
}

/** WhatsappTemplateLanguageCodes */
export enum IWhatsappTemplateLanguageCodes {
  EnUS = 'en_US',
  Fr = 'fr',
}

/** WhatsappTemplateLanguageCodes */
export enum IWhatsappTemplateCategory {
  Authentication = 'AUTHENTICATION',
  Marketing = 'MARKETING',
  Utility = 'UTILITY',
}

/** WhatsappTemplateStatuses */
export enum IWhatsappTemplateStatus {
  APPROVED = 'APPROVED',
  IN_APPEAL = 'IN_APPEAL',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  PENDING_DELETION = 'PENDING_DELETION',
  DELETED = 'DELETED',
  DISABLED = 'DISABLED',
  PAUSED = 'PAUSED',
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
  ARCHIVED = 'ARCHIVED',
}

/** WhatsappTemplateRequest */
export interface IWhatsappTemplateRequest {
  LanguageCode: IWhatsappTemplateLanguageCodes;
  /** Content */
  Content: string;
  Category: IWhatsappTemplateCategory;
}

/** WhatsappTemplateResponse */
export interface IWhatsappTemplateResponse {
  /**
   * ProfileID
   * @format uuid
   */
  ProfileID: string;
  /**
   * Id
   * @format uuid
   */
  ID: string;
  Name: string;
  LanguageCode: IWhatsappTemplateLanguageCodes;
  Category: IWhatsappTemplateCategory;
  /** Content */
  Content: string;
  Status: IWhatsappTemplateStatus;
}
